module.exports = __webpack_public_path__ + "static/img/2.ab7da045.png";